import { render, staticRenderFns } from "./CommunityResources2219.vue?vue&type=template&id=561c1b9c&scoped=true"
import script from "./CommunityResources2219.vue?vue&type=script&lang=js"
export * from "./CommunityResources2219.vue?vue&type=script&lang=js"
import style0 from "./CommunityResources2219.vue?vue&type=style&index=0&id=561c1b9c&prod&scoped=true&lang=css"
import style1 from "./CommunityResources2219.vue?vue&type=style&index=1&id=561c1b9c&prod&lang=css"
import style2 from "./CommunityResources2219.vue?vue&type=style&index=2&id=561c1b9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561c1b9c",
  null
  
)

export default component.exports